// §10.3 — the Share picker.
//
// "`share(payload)` → **the shell draws a picker** of apps whose `accepts` matches any item's mime
// → launches or focuses the target → delivers."
//
// Shell-drawn is the load-bearing word, exactly as it is for the file picker (§19.4): the sender
// must not be able to influence which app the user picks, or to learn which ones were offered. It
// says who is sharing and what, and nothing about the content beyond one line.
import { COPY } from '@/copy';
import { useKernel, useStoreValue } from '@/kernel/react';

export function SharePicker() {
  const kernel = useKernel();
  const entry = useStoreValue(kernel.shellui.store, (state) => state.shares[0]);
  if (!entry) return null;

  return (
    <div className="share-picker" role="dialog" aria-label={COPY.share.title} data-testid="share-picker">
      <h2 data-testid="share-picker-title">{COPY.share.title}</h2>
      {entry.appId !== null && (
        <p className="share-from" data-testid="share-picker-from">
          from {entry.appId}
        </p>
      )}
      <p className="share-summary" data-testid="share-picker-summary">
        {entry.request.summary}
      </p>

      <ul className="share-list" data-testid="share-picker-list">
        {entry.request.candidates.map((candidate) => (
          <li key={candidate.appId}>
            <button
              type="button"
              className="share-candidate"
              data-testid={`share-target-${candidate.appId}`}
              data-running={String(candidate.running)}
              onClick={() => kernel.shellui.acceptShare(entry.request.id, candidate.appId)}
            >
              <span
                className="share-icon"
                aria-hidden
                dangerouslySetInnerHTML={{ __html: candidate.icon }}
              />
              <span className="share-name">{candidate.name}</span>
              {/* §10.3 — "launches **or focuses**". Saying which is about to happen is honest. */}
              {candidate.running && <span className="share-running">{COPY.share.running}</span>}
            </button>
          </li>
        ))}
      </ul>

      <div className="share-actions">
        <button
          type="button"
          data-testid="share-picker-cancel"
          onClick={() => kernel.shellui.cancelShare(entry.request.id)}
        >
          {COPY.share.cancel}
        </button>
      </div>
    </div>
  );
}
